//输入控件
import React, { Component } from 'react';
import { observable, transaction, map, computed } from 'mobx';
import { tools, emitter, customFieldPrefixArray, Modal,MultInputDialog } from 'tplus-voucher';
import { autobind } from 'core-decorators';
import './TextControlWithBorder.less';
import { Ticon } from '../index';
import utilsTools from '../utils/tools'

const numTypes = ['Double', 'Int', 'Decimal'];
const EnabledEnum = { Enable: "enable", DisEnable: 'disEnable' };
const boolTypes = ['Bool'];
import { qrCodeScan,getLocationInfo,displayNearby } from 'mutants-jsbridge';
import { InputItem, Button ,Checkbox } from 'antd-mobile';




class TextControlWithBorder extends Component {

  //构造函数
  constructor(props, context) {
    //写构造方法时  必须实现父类的构造方法  否则构造失败  报错
    super(props, context);
    const { placeholder, ReadOnly, value, isPercent = false } = this.props;
    this.placeholder = placeholder != undefined ? placeholder : '请输入';
    this.placeholder = ReadOnly ? '' : this.placeholder;
    this.state = {
      placeholder: this.placeholder,
      inputValue: value,
      isBlueDialogVisible: false,
      manualInput: '', // 用户手动输入的蓝牙读数
      autoCloseBlueDialog: tools.getLocalCache('autoCloseBlueDialog') == 'true',
    }
    this.isPercent = isPercent;
    this.isCompositions = true;
    this.blueScanRef = null;

    this.blueScale = tools.getLocalCache('ScanSet_BlueScale');
  }
  /*================自定义事件====================*/

  setRef(ref) {

    if (!ref) {
      return;
    }
    this.inputRef = ref;
    if (ref.isSetEvent) {
      return;
    }
    this.inputRef.addEventListener('compositionstart', function () {//非直接的文字输入时（键盘输入中文的拼音）
      this.isCompositions = false;
    }.bind(this))
    this.inputRef.addEventListener('compositionend', function () {//直接输入文字后（键盘选择真实的汉字）
      this.isCompositions = true;
    }.bind(this))
    this.inputRef.addEventListener('input', function () {
      this.inputChange();
    }.bind(this));

    this.inputRef.addEventListener('blur', function () {
      const { FieldType } = this.props;
      if (numTypes.indexOf(FieldType) > -1 && this.inputRef && this.state.inputValue && this.inputRef.value == this.state.inputValue) {
        return;
      }
      this.isCompositions = true;
      this.inputChange();
    }.bind(this));
    ref.isSetEvent = true;
  }

  inputChange = () => {
    this.timer = setTimeout(function () {
      this.timer = null;
      if (this.isCompositions) {
        const { FieldType } = this.props;
        if (this.inputRef) {
          let value = this.inputRef.value;
          if (numTypes.indexOf(FieldType) > -1) {
            value = isNaN(value) ? '' : value;
          }
          if (this.isPercent && !tools.isEmpty(value)) {
            value = tools.div(parseFloat(value), 100);
          }
          value = this.interceptNumFile(value);
          this.onValueChange(value)
        }

      }
    }.bind(this), 500)
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value !== this.state.inputValue) {
      this.setState({
        inputValue: newProps.value
      });
    }
  }

  showBlueDialog = () => {
    this.setState({
      isBlueDialogVisible: true,
    }, () => {
      if (this.blueScanRef) {
        this.blueScanRef.focus();
      }
    });
  }

  cancelBlueDialog = () => {
    this.setState({
      isBlueDialogVisible: false,
      manualInput: ''
    });
  }

  hideBlueDialog = () => {
    this.setState({
      isBlueDialogVisible: false,
    });
    let value = this.state.manualInput;
    if (tools.isEmpty(value)) {
      return;
    }
    value = isNaN(value) ? '' : value;
    if (this.isPercent && !tools.isEmpty(value)) {
      value = tools.div(parseFloat(value), 100);
    }
    value = this.interceptNumFile(value);
    this.onValueChange(value)
    this.setState({
      manualInput: '',
    });
  }

  handleManualInput = (value) => {
    if (value.indexOf('。') >= 0) {
      value = value.replace('。', '.');
    }
    this.setState({
      manualInput: value,
    });
  }

  handleInputKeyUp = (e) => {
    if (e.keyCode === 13) {
      if (tools.getLocalCache('autoCloseBlueDialog') == 'true') {
        setTimeout(this.hideBlueDialog, 500); // Delay execution for 1 second
      }
    }
  }

  toggleAutoCloseBlueDialog = () => {
    tools.setLocalCache('autoCloseBlueDialog',!this.state.autoCloseBlueDialog);
    this.setState((prevState) => ({
      autoCloseBlueDialog: !prevState.autoCloseBlueDialog,
    }));
    if (this.blueScanRef) {
      this.blueScanRef.focus();
    }
  }


  render() {
    const { isBlueDialogVisible, manualInput, autoCloseBlueDialog} = this.state;
    const { ReadOnly, FieldType, Name, enable, value, subValue = '', isPercent = false, templateItem } = this.props;
    this.isPercent = isPercent;
    let type = numTypes.indexOf(FieldType) > -1 ? 'number' : 'text';
    if (ReadOnly || FieldType == 'Display') {
      let dispalyValue = value;
      if (dispalyValue instanceof Date) {
        dispalyValue = templateItem && templateItem.Format ? tools.dateFormat(dispalyValue, templateItem.Format) : tools.formatDate(dispalyValue);
      }
      if (boolTypes.indexOf(FieldType) >= 0) {
        dispalyValue = dispalyValue && dispalyValue != '0' && dispalyValue != 'false' ? '是' : '否'
      }
      if (this.isPercent && !tools.isEmpty(dispalyValue)) {
        dispalyValue = tools.mul(parseFloat(dispalyValue), 100) + '%';
      }
      dispalyValue += tools.isEmpty(dispalyValue) ? '' : subValue;
      if (!tools.isEmpty(dispalyValue) && type == 'number' && !isNaN(dispalyValue)) {
        dispalyValue = tools.thousandthNum(dispalyValue);
      }
      if (!tools.isEmpty(dispalyValue) && templateItem && templateItem.FieldType == 'Int' && !isNaN(dispalyValue)) {
        dispalyValue = parseInt(dispalyValue);
      }

      return (
        <p data-Name={Name}>{dispalyValue}</p>
      );
    }

    let showCounticon = false;

    if (templateItem && !tools.isEmpty(templateItem.Expression) && tools.arrayStartWith(customFieldPrefixArray, templateItem.FieldName)) {
      showCounticon = true;
    }

    let style = {};
    let placeholder = this.state.placeholder;
    if (enable == EnabledEnum.DisEnable) {
      style.border = 'none';
      placeholder = '';
    }

    let inputValue = this.state.inputValue;
    if (this.isPercent && !tools.isEmpty(inputValue)) {
      inputValue = tools.mul(inputValue, 100);
    }

    const hasSubValue = !tools.isEmpty(subValue)

    const isScan = templateItem ? templateItem.IsScanInput : false;

    return (
      <div className='detail-control-text'><input
        style={style}
        data-Name={Name}
        type={type}
        className="detail-control-input"
        placeholder={placeholder}
        value={inputValue}
        onChange={this.onChangeInput}
        onFocus={(event) => this.onFocusIn(event, type)}

        ref={ref => this.setRef(ref)} />
        {this.isPercent && <span className='persent'>%</span>}
        {hasSubValue && <span>{subValue}</span>}
        {showCounticon && <Ticon type='gongshijisuan' onClick={this.spudContent.bind(this, templateItem.FieldName)}></Ticon>}
        {isScan && enable == 'enable' && !ReadOnly && <span onClick={this.shwoScanDialog} className='icon iconfont icon-saoyisao iconScan' />}
        {templateItem && templateItem.IsMobileLocate && enable == 'enable' && !ReadOnly && <span onClick={this.getLocationInfo} className='icon iconfont icon-jingzhundingwei iconScan' />}
        {templateItem && templateItem.MaxLength > 100 && enable == 'enable' && !ReadOnly && <span onClick={this.onInputDialog} className='icon iconfont icon-shougongluru iconInput' />}
        {this.blueScale == 'true' && type == 'number' && enable == 'enable' && !ReadOnly && <span onClick={this.showBlueDialog} className='icon iconfont icon-n-lanyachengluru iconScan' />}
        <Modal
          visible={isBlueDialogVisible}
          transparent
          title="电子秤读数">
          <div>
            <InputItem
              className="blueScale-input" // Add a CSS class for styling
              placeholder="电子秤读数"
              value={manualInput}
              onChange={this.handleManualInput}
              onKeyUp={this.handleInputKeyUp}
              ref={(ref) => (this.blueScanRef = ref)} />
            <div className = 'blueScale-Check'>
              <Checkbox
                checked={tools.getLocalCache('autoCloseBlueDialog') == 'true'}
                onChange={this.toggleAutoCloseBlueDialog}
              />
              <span>获取电子秤读数后自动关闭</span>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <Button
                style={{ flex: 1 }} onClick={this.cancelBlueDialog}> 取消</Button>
              <Button
                className="blueScale-button" // Add a CSS class for styling
                style={{ backgroundColor: '#537FFB', color: 'white', flex: 1 }} // Inline style for background color
                onClick={this.hideBlueDialog}> 确定</Button>
            </div>

          </div>
        </Modal>
      </div>
    );
  }


  getLocationInfo = async () => {
    const cruLocation = await getLocationInfo();
    const locationInfo = tools.getLocalCache('OnlyGetCruLocation') == '1' ? cruLocation : await displayNearby(cruLocation);
    if (locationInfo) {
      this.onValueChange(locationInfo)
    }
  }

  shwoScanDialog = async () => {

    const { templateItem, position, value } = this.props;
    if (templateItem.ReadOnly == true) {
      return;
    }
    const scanCode = await qrCodeScan();
    console.log('scanCode=========', scanCode);
    this.onValueChange(scanCode);
    // this.setState({
    //   inputValue: scanCode
    // });
  }

  onValueChange = (value) => {
    this.props.onChange(value)
  }

  onFocusIn = (event, type) => {
    if (type && type.toLowerCase() === "number") {
      event.target.select();
    }
  }
  onChangeInput = (e) => {
    let value = e.target.value;
    const { FieldType } = this.props;
    if (numTypes.indexOf(FieldType) > -1) {
      value = isNaN(value) ? '' : value;
    }

    if (this.isPercent && !tools.isEmpty(value)) {
      value = tools.div(parseFloat(value), 100);
    }
    value = this.interceptNumFile(value);
    this.setState({
      inputValue: value
    });
  }

  onInputDialog = () =>{
    const { templateItem } = this.props;
    MultInputDialog.modal((value)=>{
      this.setState({
        inputValue: value
      });
      this.onValueChange(value)
    },templateItem.Title,this.state.inputValue,templateItem.MaxLength)
  }

  interceptNumFile = (value) => {
    const { templateItem } = this.props;
    if (templateItem && numTypes.indexOf(templateItem.FieldType) >= 0) {
      value = utilsTools.interceptNumFile(value, templateItem);
    }
    return value;
  }

  spudContent = (FieldName) => {
    let fileInfo = {}
    fileInfo.FieldName = FieldName
    fileInfo.position = this.props.position
    emitter.emit('spudContent', { FieldInfo: fileInfo });
  }

}
export default TextControlWithBorder;
